import { addAppointmentToUpdate } from '../AppointmentsUpdatesManager';


export const onUpdateAppointment = ({ err, data }) => (dispatch) => {
  if (err) throw new Error(err);

  const { appointmentUpdate: { appointmentId } } = data;

  dispatch(addAppointmentToUpdate(appointmentId));
};
